module.exports = __webpack_public_path__ + "static/30-thumb-47dd18d43daf8921bbc5c07f042fe726.jpg";